var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNordic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nordic-Sign-test-icon@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nordic-Sign-test-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "IS",
    transform: "translate(9.000000, 10.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0.08 1.08 0.08 1.08 4.74666667 0 4.74666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92833333,4.82666667 C3.55944444,4.82666667 3.20277778,4.77666667 2.85833333,4.67666667 C2.51388889,4.57666667 2.23722222,4.44666667 2.02833333,4.28666667 L2.395,3.47333333 C2.595,3.62 2.83277778,3.73777778 3.10833333,3.82666667 C3.38388889,3.91555556 3.65944444,3.96 3.935,3.96 C4.24166667,3.96 4.46833333,3.91444444 4.615,3.82333333 C4.76166667,3.73222222 4.835,3.61111111 4.835,3.46 C4.835,3.34888889 4.79166667,3.25666667 4.705,3.18333333 C4.61833333,3.11 4.50722222,3.05111111 4.37166667,3.00666667 C4.23611111,2.96222222 4.05277778,2.91333333 3.82166667,2.86 C3.46611111,2.77555556 3.175,2.69111111 2.94833333,2.60666667 C2.72166667,2.52222222 2.52722222,2.38666667 2.365,2.2 C2.20277778,2.01333333 2.12166667,1.76444444 2.12166667,1.45333333 C2.12166667,1.18222222 2.195,0.936666667 2.34166667,0.716666667 C2.48833333,0.496666667 2.70944444,0.322222222 3.005,0.193333333 C3.30055556,0.0644444444 3.66166667,0 4.08833333,0 C4.38611111,0 4.67722222,0.0355555556 4.96166667,0.106666667 C5.24611111,0.177777778 5.495,0.28 5.70833333,0.413333333 L5.375,1.23333333 C4.94388889,0.988888889 4.51277778,0.866666667 4.08166667,0.866666667 C3.77944444,0.866666667 3.55611111,0.915555556 3.41166667,1.01333333 C3.26722222,1.11111111 3.195,1.24 3.195,1.4 C3.195,1.56 3.27833333,1.67888889 3.445,1.75666667 C3.61166667,1.83444444 3.86611111,1.91111111 4.20833333,1.98666667 C4.56388889,2.07111111 4.855,2.15555556 5.08166667,2.24 C5.30833333,2.32444444 5.50277778,2.45777778 5.665,2.64 C5.82722222,2.82222222 5.90833333,3.06888889 5.90833333,3.38 C5.90833333,3.64666667 5.83388889,3.89 5.685,4.11 C5.53611111,4.33 5.31277778,4.50444444 5.015,4.63333333 C4.71722222,4.76222222 4.355,4.82666667 3.92833333,4.82666667 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNordic);
export { ForwardRef as ReactComponent };